<script setup>
import { provide, ref } from 'vue';
import ReportHeader from './components/ReportHeader.vue';
import ConversationHeatmapContainer from './components/heatmaps/ConversationHeatmapContainer.vue';
import ResolutionHeatmapContainer from './components/heatmaps/ResolutionHeatmapContainer.vue';
import AgentLiveReportContainer from './components/AgentLiveReportContainer.vue';
import TeamLiveReportContainer from './components/TeamLiveReportContainer.vue';
import StatsLiveReportsContainer from './components/StatsLiveReportsContainer.vue';
import OverviewDetailDialog from './components/overview/OverviewDetailDialog.vue';

const detailDialog = ref(null);
provide('openOverviewDetail', payload => detailDialog.value?.open(payload));
</script>

<template>
  <ReportHeader
    :header-title="$t('OVERVIEW_REPORTS.HEADER')"
    :header-description="$t('OVERVIEW_REPORTS.DESCRIPTION')"
  />
  <div class="flex flex-col gap-4 pb-6">
    <StatsLiveReportsContainer />
    <AgentLiveReportContainer />
    <TeamLiveReportContainer />
    <ConversationHeatmapContainer />
    <ResolutionHeatmapContainer />
  </div>
  <OverviewDetailDialog ref="detailDialog" />
</template>
